import React from "react";
import Paper from "@mui/material/Paper";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import Typography from "@mui/material/Typography";

export default function InternalTableSkeleton() {
  return (
    <>
      <Box mb={1} display="flex" justifyContent="flex-start">
        <Typography color="textSecondary" variant="body2">
          <Skeleton width={200} />
        </Typography>
      </Box>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                <Skeleton width={80} />
              </TableCell>
              <TableCell>
                <Skeleton width={120} />
              </TableCell>
              <TableCell>
                <Skeleton width={140} />
              </TableCell>
              <TableCell>
                <Skeleton width={110} />
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {[...Array(20)].map((_, index) => (
              <TableRow key={index} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                <TableCell component="th" scope="row">
                  <Skeleton width={100} />
                </TableCell>
                <TableCell>
                  <Skeleton width={150} />
                </TableCell>
              <TableCell>
                <Skeleton width={160} />
              </TableCell>
                <TableCell>
                  <Skeleton width={200} />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Box mb={2} mt={2} display="flex" justifyContent="center">
        <Skeleton width={300} height={40} />
      </Box>
    </>
  );
}


